import { TFunction } from 'i18next';

import type { SelectOption } from '@/shared/ui';
import { type AttachmentType } from '@/entities/consignments';

export interface AttachmentUploadFormData {
  file: File | null;
  attachmentType: AttachmentType | null;
  comment?: string;
}

export const getAttachmentTypeLabelOptions = (t: TFunction): SelectOption<AttachmentType>[] => [
  {
    value: 'WB',
    label: t('onlinesrf.attachment.type.WB.label')
  },
  {
    value: 'PL',
    label: t('onlinesrf.attachment.type.PL.label')
  },
  {
    value: 'PC',
    label: t('onlinesrf.attachment.type.PC.label')
  },
  {
    value: 'GI',
    label: t('onlinesrf.attachment.type.GI.label')
  },
  {
    value: 'GO',
    label: t('onlinesrf.attachment.type.GO.label')
  },
  {
    value: 'LR',
    label: t('onlinesrf.attachment.type.LR.label')
  },
  {
    value: 'OT',
    label: t('onlinesrf.attachment.type.OT.label')
  }
];
